'use client'

import { useLocale } from 'next-intl'
import { usePathname, useRouter } from '@/i18n/routing'
import React from 'react'
import { cn } from '@/utilities/cn'

export const LanguageToggle: React.FC = () => {
  const locale = useLocale()
  const router = useRouter()
  const pathname = usePathname()

  const handleLocaleChange = (newLocale: 'en' | 'de') => {
    router.replace(pathname, { locale: newLocale })
  }

  return (
    <div className="flex items-center gap-1 text-micro">
      <button
        className={cn(
          'px-1 py-0.5 transition-colors hover:text-neon-orange',
          locale === 'en' ? 'text-neon-orange font-bold' : 'text-white/70',
        )}
        onClick={() => handleLocaleChange('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="text-white/30">|</span>
      <button
        className={cn(
          'px-1 py-0.5 transition-colors hover:text-neon-orange',
          locale === 'de' ? 'text-neon-orange font-bold' : 'text-white/70',
        )}
        onClick={() => handleLocaleChange('de')}
        aria-label="Auf Deutsch wechseln"
      >
        DE
      </button>
    </div>
  )
}
